import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { LineChart, Line, XAxis, YAxis, ResponsiveContainer, Tooltip, CartesianGrid } from "recharts";

const CARDS = [
  { key: "total_users", label: "Total users" },
  { key: "verified_users", label: "Verified users" },
  { key: "pending_verifications", label: "Pending KYC" },
  { key: "total_debates", label: "Debates" },
  { key: "total_thoughts", label: "Thoughts" },
  { key: "total_groups", label: "Groups" },
  { key: "total_videos", label: "Videos" },
  { key: "reports_pending", label: "Reports" },
];

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data));
  }, []);

  if (!stats) return <div className="p-10 label-mono text-muted-foreground">Loading…</div>;

  return (
    <div className="p-6 lg:p-10">
      <div className="border-b border-border pb-6 mb-8">
        <div className="label-mono text-muted-foreground mb-1">Overview</div>
        <h1 className="font-serif text-4xl">Dashboard</h1>
      </div>

      {/* Metric strip */}
      <div className="grid grid-cols-2 md:grid-cols-4 border border-border mb-10">
        {CARDS.map((c, i) => (
          <div key={c.key} className={`p-5 ${i % 4 !== 3 ? "md:border-r" : ""} ${i < 4 ? "border-b md:border-b" : ""} border-border`} data-testid={`admin-stat-${c.key}`}>
            <div className="label-mono text-muted-foreground mb-2">{c.label}</div>
            <div className="font-mono text-3xl">{stats[c.key] ?? 0}</div>
          </div>
        ))}
      </div>

      {/* Growth chart */}
      <div className="border border-border p-6">
        <div className="label-mono text-muted-foreground mb-4">User growth · Last 7 days</div>
        <div className="h-64">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={stats.growth}>
              <CartesianGrid stroke="hsl(var(--border))" strokeDasharray="0" vertical={false} />
              <XAxis dataKey="day" stroke="hsl(var(--muted-foreground))" fontSize={11} tick={{ fontFamily: "IBM Plex Mono" }} />
              <YAxis stroke="hsl(var(--muted-foreground))" fontSize={11} tick={{ fontFamily: "IBM Plex Mono" }} allowDecimals={false} />
              <Tooltip contentStyle={{ backgroundColor: "hsl(var(--card))", border: "1px solid hsl(var(--border))", borderRadius: 0, fontFamily: "IBM Plex Mono" }} />
              <Line type="monotone" dataKey="users" stroke="hsl(var(--foreground))" strokeWidth={2} dot={{ fill: "hsl(var(--foreground))", r: 3 }} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
